import { render } from "./WelcomePageFaq.vue?vue&type=template&id=b8d58098&scoped=true"
import script from "./WelcomePageFaq.vue?vue&type=script&lang=js"
export * from "./WelcomePageFaq.vue?vue&type=script&lang=js"

import "./WelcomePageFaq.vue?vue&type=style&index=0&id=b8d58098&scoped=true&lang=css"

import exportComponent from "/var/www/html/bcsprostuti-web-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8d58098"]])

export default __exports__